import { API, ApiService, type Logger, LOGGER } from "@packages/common";
import { Inject, Injectable } from "@webmotors/ioc";
import { LocationApiResponse } from "./dtos";
import { State } from "./models";
import { StateTransformer } from "./transformers";

@Injectable("LocationService")
export class LocationService {
  /**
   * Logger instance
   *
   */
  private logger: Logger;

  /**
   * Location service constructor
   *
   * @param api
   */
  constructor(
    @Inject(API) private api: ApiService,
    @Inject(LOGGER) private loggerFactory: Logger,
  ) {
    this.logger = this.loggerFactory.create("LocationService");
  }

  /**
   * Fetch all available cities
   *
   * @returns
   */
  async fetch(vehicleType: "car" | "bike"): Promise<State[]> {
    try {
      const data = await this.api.get<unknown, LocationApiResponse>(
        `/filter/${vehicleType}/LocationSearch`,
      );

      const filteredData = data.filter((item) => item.Count > 0);

      return StateTransformer.transform(filteredData);
    } catch (e) {
      this.logger.error("Error fetching states", e);

      return [];
    }
  }
}
